
import {
    Button,
    Col,
    Input,
    Label,
} from "reactstrap";

const GetOTPForm = ({ otp, setOtp, handleResendOtp }) => {

    return (
        <div className="mb-3">
        <label className="form-label">Enter OTP</label>
        <div className="form-floating flex-grow-1 mt-1">
          <Input
            type="text"
            placeholder="Enter 6-digit OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            className="mb-2"
            style={{
              padding: "0.75rem 0.75rem 0.8rem 0.75rem",
            }}
          />
          <Label for="mobile_number" className="form-label">
            Enter 6-digit OTP
          </Label>
        </div>
        <div className="d-flex justify-content-between align-items-center">
          <small className="text-muted">Didn't Receive OTP?</small>
          <Button
            color="link"
            className="p-0 text-decoration-none"
            onClick={handleResendOtp}
            type="button"
          >
            Resend OTP
          </Button>
        </div>
      </div>
);
};

export default GetOTPForm;
